import 'flag-icons/css/flag-icons.min.css';
import { Button } from 'primereact/button';
import { useLanguageContext } from '../../contexts/LanguageContext';
import LanguageSelection from '../Language/LanguageSelection';
import styles from './Wrapper.module.scss';
import { ChevronRight } from 'lucide-react';
function PageWrapper({ label, labelAction, actions, children, detail, search, disable, hideLanguageSelector = false }) {
  const { availableLanguages } = useLanguageContext();

  return (
    <div className={styles.pageWrapper} style={{ opacity: disable ? 0.4 : 1, }}>
      <div className={styles.headerContainer} style={{ pointerEvents: disable ? 'none' : 'auto' }}>
        <div className={styles.fil}>
          <p
            onClick={() => labelAction(undefined)}
            style={{ opacity: detail ? 0.5 : 1, cursor: detail ? 'pointer' : 'default' }}
            className={styles.filTitle}>
            {label}
          </p>
          {detail && <ChevronRight className={styles.filChevron} />}
          {detail && <p className={styles.filTitle}>{detail.title}</p>}
        </div>

        <div className={styles.buttonList}>
          {search}
          {/* {action && (
            <Button
              key="additionnal"
              size="medium"
              iconPos="left"
              icon={`pi ${action.icon}`}
              label={action.label}
              onClick={action.onClick}
              className={styles.pill}
              text
              rounded
            />
          )} */}
          {actions &&
            actions.map((action, index) => (
              <Button
                key={index}
                size="small"
                outlined
                rounded
                label={action.label ? action.label : null}
                iconPos="left"
                icon={action.icon ? `pi ${action.icon}` : null}
                onClick={action.onClick}
                className={`${styles.pill} ${action.isSelected ? styles.pillSelected : ''}`}
                aria-label={action.ariaLabel ? action.ariaLabel : action.label}

              />
            ))}
          {!hideLanguageSelector && (availableLanguages?.length > 1) && <LanguageSelection />}
        </div>
      </div>

      {children}
    </div>
  );
}

export default PageWrapper;
